class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.sectionHeader = document.getElementById('shopify-section-header');
    this.notification = document.getElementById('cart-notification');
    this.notificationOverlay = document.getElementById('cart-notification-overlay');
    this.body = document.querySelector('body');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.stickyHeader = document.querySelector('sticky-header');
    this.announcementBar = document.getElementById('announcement-bar-wrapper');
    this.conciergePopup = document.querySelector('[minicart-harper-popup]');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
    //   closeButton.addEventListener('click', this.close.bind(this));
    // });
    let cartLink = document.getElementById('cart-icon-bubble');
    this.notification.addEventListener('click', function(e){
      if(e.target && e.target.dataset.close == ''){
        document.getElementById('cart-notification-overlay').classList.remove('active');
        document.getElementById('cart-notification').classList.remove('active');
        document.body.removeEventListener('click', this.onBodyClick);
        removeTrapFocus(this.activeElement);
        cartLink.style.display = 'flex';
        document.getElementById('cart-icon-bubble-close').style.display = 'none';
        document.querySelector('body').classList.remove('tw-overflow-hidden');
      }
    });
    if (!cartLink.hasAttribute('data-wishlist')) {
      cartLink.addEventListener('click', this.openSideCart.bind(this), false);
    }

    const cartSearchLink = document.querySelector('li[cart-search-link]');
    const cartLoginLink = document.querySelector('li[cart-login-link]');
    const cartBagLink = document.querySelector('li[cart-bag-link-desktop]');
    const cartLocalizationButton = document.querySelector('li[cart-localization-btn]');
    const headerCart = document.querySelector('.header__icon--cart-desktop');
    const headerSearch = document.querySelector('.header__search .header__icon--search'); 
    const harperMinicartModal = document.querySelector("#harper-minicart-modal");

    window.addEventListener("resize", this.calcPositionOfNotification.bind(this));
    cartSearchLink.addEventListener('click', () => {
      headerSearch.click();
      setTimeout(() => {
        if (harperMinicartModal)
          harperMinicartModal.classList.add("harper-closed");
        headerSearch.click();
      }, 100);
    });
    
    cartLoginLink.addEventListener('click', () => {
      if (harperMinicartModal)
        harperMinicartModal.classList.add("harper-closed");
      document.querySelector('span[header_login_link]').click();
    });

    cartBagLink.addEventListener('click', () => {
      if (harperMinicartModal)
        harperMinicartModal.classList.add("harper-closed");
      headerCart.click();
    });

    cartLocalizationButton.addEventListener('click', () => {
      if (harperMinicartModal)
        harperMinicartModal.classList.add("harper-closed");
      headerCart.click();
    });
  }

  openSideCart(evt) {
    evt.preventDefault();
    this.renderContents();
  }

  open() {
    // this.notification.classList.add('animate', 'active');
    this.calcPositionOfNotification();
    this.notification.classList.add('active');
    this.notificationOverlay.classList.add('active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);

    document.getElementById('cart-icon-bubble').style.display = 'none';
    document.getElementById('cart-icon-bubble-close').style.display = 'flex';
    enableScrollLock(this);

    const discountMessage = document.getElementById('cart-message-discount');
    if (!discountMessage) {
      return;
    }
    if (document.cookie.match(/discount_code=/)){
      discountMessage.classList.add('visible');
      discountMessage.classList.remove('hidden');
    } else {
      discountMessage.classList.add('hidden');
      discountMessage.classList.remove('visible');
    }
  }

  close() {
    this.notification.classList.remove('active');
    this.notificationOverlay.classList.remove('active');
    if (this.conciergePopup) {
      this.conciergePopup.classList.remove('harper-opened');
      this.conciergePopup.classList.add('harper-closed');
    }

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);

    document.getElementById('cart-icon-bubble').style.display = 'flex';
    document.getElementById('cart-icon-bubble-close').style.display = 'none';
    disableScrollLock(this);
  }

  renderContents(parsedState) {
    if (parsedState) {
      this.productId = parsedState.id;
      const harperCheckout = document.getElementById('harper_checkout');
      if (harperCheckout)
        harperCheckout.style.display = 'block';
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
    }

    this.header?.reveal();
    if (parsedState) {
      // Fix for Safari on mobile where address bar disappears.
      setTimeout(() => this.open(), 250);
    } else {
      this.open();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'//,
        // selector: `#cart-notification-product-${this.productId}`,
      },
      {
        // id: 'cart-notification-button'
        id: 'cart-icon-bubble-close'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification') && !target.closest('#cart-icon-bubble') && !target.closest('#harper-minicart-modal') || target == this.notificationOverlay) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  calcPositionOfNotification() {
  
    if (!this.notification || !this.stickyHeader) {
      return;
    }

    let elementsToPosition = [this.notification, this.notificationOverlay, this.conciergePopup];

    if (window.innerWidth >= 1280 && !this.announcementBarIsOnScreen) {
      // Defaults to be placed at the top of the viewport but need to reset.
      this.resetPosition(elementsToPosition);
      return;
    }

    if (window.innerWidth >= 1280) {
      this.positionBelowAnnouncementBar(elementsToPosition);
      return;
    }
  
    if (window.innerWidth < 768) {
      elementsToPosition = [this.notification, this.notificationOverlay];
      this.resetPosition([this.conciergePopup]);
    }

    this.positionBelowStickyHeader(elementsToPosition);
  }

  resetPosition(elementsToPosition) {
    elementsToPosition.filter(Boolean).forEach(elementToPosition => {
      elementToPosition.style.removeProperty('top');
      elementToPosition.style.removeProperty('height');
    });
  }

  positionBelowStickyHeader(elementsToPosition) {
    const stickyHeaderBounds = this.stickyHeader.getBoundingClientRect();
    const bottomPositionOfStickyHeader = stickyHeaderBounds.bottom + 'px';

    elementsToPosition.filter(Boolean).forEach(elementToPosition => {
      elementToPosition.style.setProperty('top', `${bottomPositionOfStickyHeader}`, 'important');
      elementToPosition.style.setProperty('height', `calc(100dvh - ${bottomPositionOfStickyHeader})`, 'important');
    });
  }

  positionBelowAnnouncementBar(elementsToPosition) {
    const announcementBarBounds = this.announcementBar.getBoundingClientRect();
    const bottomPositionOfannouncementBar = announcementBarBounds.bottom + 'px';

    elementsToPosition.filter(Boolean).forEach(elementToPosition => {
      elementToPosition.style.setProperty('top', `${bottomPositionOfannouncementBar}`, 'important');
      elementToPosition.style.setProperty('height', `calc(100dvh - ${bottomPositionOfannouncementBar})`, 'important');
    });
  }

  get announcementBarIsOnScreen() {
    return this.announcementBarVisibleHeight > 0;
  }

  get announcementBarVisibleHeight() {
    return this.announcementBar && this._calcVisibleHeight(this.announcementBar);
  }

  _calcVisibleHeight(element) {
    const elementRect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  
    // Calculate the visible height
    const visibleHeight = Math.max(0, Math.min(elementRect.bottom, windowHeight) - Math.max(elementRect.top, 0));
  
    return visibleHeight;
  }
}

customElements.define('cart-notification', CartNotification);